var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.showSnackbar,"color":"#1c344b","dark":"","timeout":"-1","bottom":"","left":""}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{staticClass:"text--white",attrs:{"dark":"","text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }